import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2812bfcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-map" }
const _hoisted_2 = { class: "full-map__header" }
const _hoisted_3 = { class: "items-in-line gap--5" }
const _hoisted_4 = { class: "items-in-line gap--5" }
const _hoisted_5 = {
  key: 0,
  class: "center full-map__loading"
}
const _hoisted_6 = { class: "items-in-line gap--5" }
const _hoisted_7 = { class: "full-map__search-modal" }
const _hoisted_8 = { class: "allBlockWidth pt--10 pb--10 pr--10 pl--10" }
const _hoisted_9 = {
  key: 0,
  class: "items-in-line gap--5"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Показать", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  class: "items-in-line gap--5"
}

import { MapBlock } from '@/components';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { OfferCardCoordinatesType } from '@/api/house/types';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { FilterBlock, FilterBtns } from '@/components/MainPageComponents';
import InputGroup from '@/components/MainPageComponents/Banner/InputGroup/InputGroup.vue';
import { createDecliningLabel } from '@/utils/Common/Common';


export default /*#__PURE__*/_defineComponent({
  __name: 'FullMapSearch',
  setup(__props) {

const isShowFilterBlock = ref(false);
const isShowSearchBlock = ref(false);

const resultCardsCoordinates = computed((): OfferCardCoordinatesType[] => {
  return useOfferCardsStore().offerCardsCoordinates;
});
const isLoading = computed(() => {
  return useOfferCardsStore().isLoadingResultBlock;
});

const activeFilterBtn = computed(() => {
  const param306 = useOfferCardsStore().params[306]?.value;

  if (param306) {
    switch (param306) {
      case '265':
        return useOfferCardsStore().filterBtnsByType[0];
      case '266':
        return useOfferCardsStore().filterBtnsByType[1];
      case '267':
        return useOfferCardsStore().filterBtnsByType[2];
    }
  } else {
    return useOfferCardsStore().filterBtnsByType[0];
  }
});

onMounted(() => {
  useOfferCardsStore().toggleIsShowResultBlock(false);
});

onUnmounted(() => {
  useOfferCardsStore().hideMapBlock();
});

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_base_icon, {
          clickable: "",
          color: "#000000",
          name: "arrow_back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'main', hash: '#list', query: _ctx.$route.query })))
        }),
        _createVNode(_component_base_button, {
          "all-block-width": "",
          "style-type": "grey",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowSearchBlock.value = true))
        }, {
          text: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_base_icon, {
                color: "#009D3E",
                name: "search"
              }),
              _createTextVNode(" Поиск ")
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_base_button, {
          "all-block-width": "",
          "style-type": "grey",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowFilterBlock.value = true))
        }, {
          text: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_icon, {
                color: "#009D3E",
                name: "tune"
              }),
              _createTextVNode(" Фильтры ")
            ])
          ]),
          _: 1
        })
      ]),
      (_unref(useOfferCardsStore)().isLoadingResultBlock)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_base_spinner, {
              size: 50,
              color: "#009D3E"
            })
          ]))
        : (_openBlock(), _createBlock(_unref(MapBlock), {
            key: 1,
            resultCardsCoordinates: resultCardsCoordinates.value,
            height: "100%",
            "is-full": "",
            showOfferCard: ""
          }, null, 8, ["resultCardsCoordinates"])),
      _createVNode(_component_base_button, {
        class: "full-map__list-btn",
        height: "36",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'main', hash: '#list' })))
      }, {
        text: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_base_icon, {
              color: "#ffffff",
              name: "list"
            }),
            _createTextVNode(" Список ")
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(FilterBlock), {
      "is-show-filter-block": isShowFilterBlock.value,
      isFilterByTerritory: activeFilterBtn.value?.id === 3,
      "show-list-block": false,
      "show-coordinates": "",
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isShowFilterBlock.value = false))
    }, null, 8, ["is-show-filter-block", "isFilterByTerritory"]),
    _createVNode(_component_base_modal, {
      "show-modal": isShowSearchBlock.value,
      "close-outside": "",
      "custom-modal": "",
      "hide-title": "",
      onClose: _cache[6] || (_cache[6] = ($event: any) => (isShowSearchBlock.value = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(FilterBtns), { class: "full-map__search-modal-filter-btns" }),
          _createVNode(InputGroup, { height: "44" }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_base_button, {
              "all-block-width": "",
              height: "36",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (isShowSearchBlock.value = false))
            }, {
              text: _withCtx(() => [
                (resultCardsCoordinates.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      (isLoading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _createVNode(_component_base_spinner)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(resultCardsCoordinates.value.length), 1)),
                      _createElementVNode("span", null, _toDisplayString(_unref(createDecliningLabel)(resultCardsCoordinates.value.length, [
                        'объект',
                        'объекта',
                        'объектов',
                      ])), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, "Показать"))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show-modal"])
  ]))
}
}

})